import { useCallback } from "react";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { LeadDetail } from "@/components/LeadDetail";
import { LeadSections } from "@/components/LeadSections";
import { ClienteSections } from "@/components/ClienteSections";
import { FieraFields } from "@/pages/LeadForm";
import { validateCliente } from "@/lib/clienteConstants";
import { ConsentChecks } from "@/components/ConsentChecks";
import { TOKEN_KEY } from "@/lib/api";

const CONFIGS = {
  leads: {
    backPath: "/storico",
    titleOf: (f) => f.ragione_sociale || f.nome_buyer,
    validate: () => null,
    render: (p) => (
      <>
        <FieraFields form={p.form} set={p.set} prefix="detail-" />
        <LeadSections {...p} />
        <ConsentChecks form={p.form} set={p.set} />
      </>
    ),
  },
  clienti: {
    backPath: "/anagrafica/elenco",
    titleOf: (f) => f.ragione_sociale || f.insegna || f.referenti?.[0]?.nome,
    validate: (f) => validateCliente(f, false),
    render: (p) => (
      <>
        <ClienteSections form={p.form} set={p.set} />
        <ConsentChecks form={p.form} set={p.set} />
      </>
    ),
  },
};

export default function LeadDetailPage({ endpoint = "leads" }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const cfg = CONFIGS[endpoint];
  const token = localStorage.getItem(TOKEN_KEY) || "";
  const goBack = useCallback(() => navigate(cfg.backPath), [navigate, cfg.backPath]);
  const onUnauthorized = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    navigate(cfg.backPath);
  }, [navigate, cfg.backPath]);

  if (!token) return <Navigate to={cfg.backPath} replace />;
  return (
    <LeadDetail
      key={`${endpoint}-${id}`}
      leadId={id}
      token={token}
      endpoint={endpoint}
      config={cfg}
      onClose={goBack}
      onUnauthorized={onUnauthorized}
    />
  );
}
